import { render } from "./myPlayListDice.vue?vue&type=template&id=d8a920b2&scoped=true"
import script from "./myPlayListDice.vue?vue&type=script&lang=js"
export * from "./myPlayListDice.vue?vue&type=script&lang=js"

import "./myPlayListDice.vue?vue&type=style&index=0&id=d8a920b2&scoped=true&lang=css"
import "./myPlayListDice.vue?vue&type=style&index=1&id=d8a920b2&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a920b2"]])

export default __exports__